<template>
  <div
    class="pb-40 bg-slate-300"
    :style="{ minHeight: 'calc(100vh - 4.5rem - 0.5rem)' }"
  >
    <div class="analytics-sticky pt-4 px-6">
      <div class="flex items-center justify-between">
        <BlTextTitle3 text="Acquisition Comparison" />
      </div>
    </div>
    <div class="fixed bottom-0 right-0 z-40 p-6">
      <button
        class="h-25 w-25 flex flex-col items-center justify-center gap-1 bg-light-purple hover:bg-dark-purple-200 rounded-full border-2 border-pure-white shadow-lg outline-none"
        :class="{ 'cursor-wait': createLoading }"
        title="New comparison graph"
        @click="onCreate"
        :disabled="createLoading"
      >
        <BlIcon icon="plus" color="secondary" />
        <BlTextSubtitle3 class="text-pure-white" text="New" />
      </button>
    </div>
    <!--  -->
    <div v-if="fetchLoading" class="h-100 grid place-items-center">
      <div class="blum-loader"></div>
    </div>
    <div
      v-else-if="!comparisonGraphs.length"
      class="h-100 grid place-items-center"
    >
      <div>
        <BlTextBody2 text="Data not found." />
      </div>
    </div>
    <draggable
      v-else
      handle=".handle_comparison"
      @update.prevent="onMove($event)"
      class="py-4 px-6 flex flex-col gap-6"
    >
      <AcquisitionGraph
        v-for="comparison in comparisonGraphs"
        :key="comparison.id"
        :id="comparison.id"
        :comparisonGraph="comparison"
      />
    </draggable>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import draggable from "vuedraggable";

import AcquisitionGraph from "./comparison/AcquisitionGraph.vue";

import BlTextTitle3 from "../BlTextTitle3.vue";
import BlTextSubtitle3 from "../BlTextSubtitle3.vue";
import BlTextBody2 from "../BlTextBody2.vue";
import BlIcon from "../BlIcon.vue";
import BlInputPagination from "../BlInputPagination.vue";

export default {
  name: "AcquisitionComparison",
  components: {
    draggable,
    AcquisitionGraph,
    BlTextTitle3,
    BlTextSubtitle3,
    BlTextBody2,
    BlIcon,
    BlInputPagination
  },
  data() {
    return {
      fetchLoading: false,
      createLoading: false,
      saveLoading: false,
      page: 1,
      perPage: 25
    };
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "currentCenter",
      "stages",
      "comparisonGraphs",
      "totalComparisonGraphs"
    ]),
    enableSalesPipeline() {
      return this.currentCenter.enable_sales_pipeline;
    },
    enableBranch() {
      return this.currentCenter.enable_branch;
    },
    searchParams() {
      return this.$route.query || {};
    },
    paramsTab() {
      return this.$route.params.tab;
    }
  },
  mounted() {
    if (!this.enableSalesPipeline) {
      return this.$router.push({ name: "Analytics" });
    }

    const searchParams = this.searchParams;

    if (searchParams["page"]) {
      this.page = Number(searchParams["page"]);
    }
    if (searchParams["per_page"]) {
      this.perPage = Number(searchParams["per_page"]);
    }

    this.fetchComparisonGraphs();
  },
  methods: {
    ...mapActions([
      "getComparisonGraphs",
      "createComparisonGraph",
      "updateComparisonGraph"
    ]),
    syncPath() {
      let params = `?page=${this.page}&per_page=${this.perPage}`;

      // sync url path for page
      const incomingPath = "/analytics/acquisition-comparison" + params;
      if (this.$route.fullPath !== incomingPath) {
        return this.$router.push(incomingPath);
      }
    },
    fetchComparisonGraphs() {
      let params = `?page=${this.page}&per_page=${this.perPage}`;
      params += `&type=ComparisonGraph::Acquisition`;
      this.fetchLoading = true;
      this.getComparisonGraphs({ params }).then(({ success }) => {
        this.fetchLoading = false;
        // if (!success) return;
      });
      this.syncPath();
    },
    onCreate() {
      const interval = "year";
      const defaultDate = {
        start_date: moment()
          .startOf(interval)
          .format("YYYY-MM-DD"),
        end_date: moment()
          .endOf(interval)
          .format("YYYY-MM-DD")
      };
      const data = {
        comparison_graph: {
          type: "ComparisonGraph::Acquisition",
          position: this.comparisonGraphs.length + 1,
          filter_data: {
            branch_ids: "all", // branch ids separated by comma, "all" (all prospect with branch), "no_branch"
            calculation_method: "prospects_per_stage",
            stage_id: this.stages[0].id,
            group_by: "month", // day, week, month, year
            start_date: defaultDate.start_date,
            end_date: defaultDate.end_date
          }
        }
      };
      this.createLoading = true;
      this.createComparisonGraph(data).then(({ success }) => {
        this.createLoading = false;
        // if (!success) return;
      });
    },
    onMove(event) {
      const id = event.item.id;
      const graphId = Number(id);
      const graph = this.comparisonGraphs.find(i => i.id === graphId);
      if (!graph) return;
      const newPosition = event.newIndex + 1;
      if (graph.position === newPosition) return;

      const data = {
        id: graph.id,
        comparison_graph: {
          position: newPosition
        }
      };
      this.saveLoading = true;
      this.updateComparisonGraph(data).then(({ success }) => {
        this.saveLoading = false;
        // if (!success) return;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.analytics-sticky {
  width: calc(100vw - 15rem - 0.5rem);
  position: sticky;
  left: 15rem;
}
</style>



// WEBPACK FOOTER //
// src/components/analytics/AcquisitionComparison.vue